import React from 'react';
import LoadableView from './Loadable';

interface Props {
  isEnabled: boolean;
}

const Switch = ({ isEnabled }: Props) => {
  if (isEnabled) {
    return <LoadableView />;
  }
  return null;
};

export default Switch;
